import { multiply } from "./core.js"

const subMultiply = (data, operation) => {
    const { fieldsToOperate, targetField, subEntity } = operation

    if (!data[subEntity] || !Array.isArray(data[subEntity])) {
        return data
    }

    // Create new array with updated elements instead of mutating
    const newSubArray = data[subEntity].map(elem => {
        const result = multiply(elem, fieldsToOperate)
        return {
            ...elem,
            [targetField]: parseFloat(result)
        }
    })

    // Return new object with updated array
    return {
        ...data,
        [subEntity]: newSubArray
    }
}

export default subMultiply
